export default __webpack_public_path__ + "static/media/EG_Snappy-2.38861e77.wav";